import * as React from "react";
import { Stack, Text } from "office-ui-fabric-react";
import { mdiPackageVariant } from "@mdi/js";
import Icon from "@mdi/react";

export interface NoDataTileProps {
  icon?: string;
  title: string;
  description?: string;
}

class NoDataTile extends React.Component<NoDataTileProps> {
  size = this.props.description ? 48 : 32;
  render() {
    return (
      <Stack horizontal horizontalAlign="center" verticalAlign="center">
        <Stack.Item>
          <Icon path={mdiPackageVariant} style={{ fontSize: this.size, height: this.size, width: this.size, margin: 8 }} color="#666" />
        </Stack.Item>
        <Stack.Item>
          <Stack>
            <Stack.Item>
              <Text styles={{ root: { color: "#666" } }} variant="xLarge">
                {this.props.title}
              </Text>
            </Stack.Item>
            <Stack.Item>
              <Text variant="small" styles={{ root: { color: "#666" } }}>
                {this.props.description}
              </Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
      </Stack>
    );
  }
}

export default NoDataTile;
